export const matriculadoColumns = [
  {
    accessor: 'firstName',
    Header: 'Nombre',
    headerProps: { title: 'Ordenar por nombre' }
  },
  {
    accessor: 'lastName',
    Header: 'Apellido',
    headerProps: { title: 'Ordenar por apellido' }
  },
  {
    accessor: 'email',
    Header: 'Email',
    headerProps: { title: 'Ordenar por email' }
  },
  {
    accessor: 'dni',
    Header: 'DNI',
    headerProps: { title: 'Ordenar por DNI' }
  },
  {
    accessor: 'matricula',
    Header: 'Matrícula',
    headerProps: { title: 'Ordenar por matrícula' }
  },
  {
    accessor: 'bypassed',
    Header: 'Con login directo',
    headerProps: { title: 'Ordenar por login directo' }
  },
  {
    accessor: 'created_at',
    Header: 'Fecha de creación',
    headerProps: { title: 'Ordenar por fecha de creación' }
  },
  {
    accessor: 'actions',
    Header: 'Acciones',
    headerProps: { style: { cursor: 'default' }, title: null, onClick: null }
  }
];
